module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_58.2449951d.png";